module.exports = __webpack_public_path__ + "img/deploy_diagram.fb5a6bf9.png";